import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module} from 'ng-recaptcha';

import {AgmCoreModule, GoogleMapsAPIWrapper} from '@agm/core';

import {
  MatSidenavModule,
  MatProgressBarModule,
  MatToolbarModule,
  MatButtonModule,
  MatListModule,
  MatFormFieldModule,
  MatInputModule,
  MatDialogModule,
  MatCardModule,
  MatOptionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MatTabsModule,
  MatExpansionModule,
  MatCheckboxModule,
  MatRadioModule,
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderComponent } from './components/loader/loader.component';

import {LoaderService} from './services/loader.service';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import {LoaderInterceptor} from './loader-interceptor';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { AlertPopComponent } from './components/alert-pop/alert-pop.component';
import { ConfirmPopComponent } from './components/confirm-pop/confirm-pop.component';
import { RegistroUsuarioComponent } from './components/registro-usuario/registro-usuario.component';
import { ActivateUserComponent } from './components/activate-user/activate-user.component';
import { RecuperarContrasenaComponent } from './components/recuperar-contrasena/recuperar-contrasena.component';
import { ChangePasswordRecoveryComponent } from './components/change-password-recovery/change-password-recovery.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { MisUpaegsComponent } from './components/mis-upaegs/mis-upaegs.component';
import { VinculateUpaegComponent } from './components/vinculate-upaeg/vinculate-upaeg.component';
import { UpaegFisicaComponent } from './components/upaeg-fisica/upaeg-fisica.component';
import { UpaegMoralComponent } from './components/upaeg-moral/upaeg-moral.component';
import { UpaegGrupalComponent } from './components/upaeg-grupal/upaeg-grupal.component';
import { PresolicitudesComponent } from './components/presolicitudes/presolicitudes.component';
import { PresolicitudComponent } from './components/presolicitud/presolicitud.component';
import { DisponibilidadComponent } from './components/disponibilidad/disponibilidad.component';
import { UpaegsApoyoComponent } from './components/upaegs-apoyo/upaegs-apoyo.component';
import { ChangeEmailComponent } from './components/change-email/change-email.component';
import { SetNewEmailComponent } from './components/set-new-email/set-new-email.component';
import { GeoComponentComponent } from './components/geo-component/geo-component.component';
import { MisTicketsComponent } from './components/mis-tickets/mis-tickets.component';
import { CrearTicketComponent } from './components/crear-ticket/crear-ticket.component';
import { TicketTalkComponent } from './components/ticket-talk/ticket-talk.component';
import { ValidarEmailPresolComponent } from './components/validar-email-presol/validar-email-presol.component';
import { InputTrimModule } from 'ng2-trim-directive';
import { VincularDocumentoExpedienteComponent } from './components/vincular-documento-expediente/vincular-documento-expediente.component';
import { UserPopComponent } from './components/user-pop/user-pop.component';



@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    HomeComponent,
    LoginComponent,
    AlertPopComponent,
    ConfirmPopComponent,
    RegistroUsuarioComponent,
    ActivateUserComponent,
    RecuperarContrasenaComponent,
    ChangePasswordRecoveryComponent,
    MyProfileComponent,
    MisUpaegsComponent,
    VinculateUpaegComponent,
    UpaegFisicaComponent,
    UpaegMoralComponent,
    UpaegGrupalComponent,
    PresolicitudesComponent,
    PresolicitudComponent,
    DisponibilidadComponent,
    UpaegsApoyoComponent,
    ChangeEmailComponent,
    SetNewEmailComponent,
    GeoComponentComponent,
    MisTicketsComponent,
    CrearTicketComponent,
    TicketTalkComponent,
    ValidarEmailPresolComponent,
    VincularDocumentoExpedienteComponent,
    UserPopComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatListModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    HttpClientModule,
    MatDialogModule,
    MatCardModule,
    RecaptchaV3Module,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatRadioModule,
    InputTrimModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA9X8n3vB1RrQHJfmRGgRP9PASNRXgksMg',
      libraries: ['drawing']
    })
  ],
  providers: [
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: '6Lf4GMYUAAAAAK09fYpAmL2HrCvtw59I_GEXtUf2' },
    {provide: MAT_DATE_LOCALE, useValue: 'es-MX'},
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmPopComponent,
    AlertPopComponent,
    VincularDocumentoExpedienteComponent,
    UserPopComponent
  ]
})
export class AppModule { }
